import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ProductListing from "../../../model/ProductListing";

export const set_to_master_data_only_products_list = createAsyncThunk(
    'product_fetchListingFromServer',
    async (direct_res) => {
        let ERPPartNumbers_asked_params = false;
        let config = false;
        if (direct_res.config !== undefined) {
            config = direct_res.config;
        }
        if (config.ERPPartNumbers_asked_params !== undefined) {
            ERPPartNumbers_asked_params = config.ERPPartNumbers_asked_params;
        }
        return new ProductListing().toObjectWithERPPartNumber(direct_res, ERPPartNumbers_asked_params);
    });

const slice = createSlice({
        name: "ProductListing",
        initialState: {
            data: {},
            category_filter_applied_status: false,
            append_facade_options_status: false,
            master_data_only_products_list: {},
            ItemNumber_map_with_ERPPartNumber: {},
            ERPPartNumber_map_with_ItemNumber: {},
        },
        reducers: {
            setAll: {
                reducer: (state, action) => {
                    state.data = action.payload.data
                },
            },
            set_category_filter_applied_status: {
                reducer: (state, action) => {
                    state.category_filter_applied_status = action.payload.status
                },
            },
            set_append_facade_options_status: {
                reducer: (state, action) => {
                    state.append_facade_options_status = action.payload.status
                },
            },
        },
        extraReducers: {
            [set_to_master_data_only_products_list.fulfilled]: (state, {payload}) => {
                let data = payload;
                data = Object.entries(data);
                if (data.length) {
                    data.map((v, i) => {
                        state.master_data_only_products_list[v[1].ERPPartNumber] = v[1]
                        state.master_data_only_products_list[v[1].ItemNumber] = v[1]
                        state.ItemNumber_map_with_ERPPartNumber[v[1].ItemNumber] = v[1].ERPPartNumber
                        state.ERPPartNumber_map_with_ItemNumber[v[1].ERPPartNumber] = v[1].ItemNumber
                    })
                }
                return state;
            },
        },
    })
;

export let {setAll, set_category_filter_applied_status, set_append_facade_options_status} = slice.actions;

export default slice.reducer;
